var ChiliPiperDS_FormHelpers = new Object();

ChiliPiperDS_FormHelpers.version = "1.0.0";

ChiliPiperDS_FormHelpers.getSubmitBtn = function ($form) {
  return $form.find(".hs_submit.hs-submit input.submit-btn");
};

ChiliPiperDS_FormHelpers.getConsentField = function ($form) {
  const $el = $form.find('.legal-consent-container .hs-input[type="checkbox"]');

  return $el;
};

ChiliPiperDS_FormHelpers.getDemoTypeField = function ($form) {
  const $el = $form.find(
    '.field.hs-form-field.hs_requested_demo_type .hs-input[name="requested_demo_type"]',
  );

  return $el;
};

ChiliPiperDS_FormHelpers.getDemoTypeCheckedField = function ($form) {
  const $el = $form.find(
    '.field.hs-form-field.hs_requested_demo_type .hs-input[name="requested_demo_type"]:checked',
  );

  return $el;
};

ChiliPiperDS_FormHelpers.preventFormSubmit = function ($form) {
  const $submitBtn = this.getSubmitBtn($form);

  $submitBtn.prop("disabled", true);

  return;
};

ChiliPiperDS_FormHelpers.redirectToDemoVideo = function (access) {
  if (access) {
    helpers.Cookie.set("demoVideoAccessGranted", "1");
  }
  /*
   * DESTINATION IS OVERRIDABLE, the rest of the flow is not. `data-redirect` on the form body
   * comes from the shortcode's `redirect` attribute; with none set this is exactly what it has
   * always been, /video-demo/ on the current origin.
   *
   * THE QUERY STRING IS CARRIED EITHER WAY. It is how the destination knows anything about the
   * visitor — 1mind's own guide calls URL parameters the right fit for a redirect-to-thank-you
   * flow, as against data attributes for replacing a form in place.
   */
  // $el starts as null (index.js) and is only set on init, so it is checked rather than assumed —
  // the same `_parent` pattern the neighbouring helpers use.
  var _parent = ChiliPiperDS;
  const override =
    _parent.$el && _parent.$el[0] ? _parent.$el[0].getAttribute("data-redirect") || "" : "";
  const base = override || window.location.origin + "/video-demo/";
  const redirectLink = base + window.location.search;
  location.href = redirectLink;

  if (helpers.shouldDebug("ds3"))
    console.log("[ChiliPiperDS.FormHelpers] redirectToDemoVideo", redirectLink);

  return;
};

ChiliPiperDS_FormHelpers.setAdditionalRequiredFields = function ($form) {
  var _parent = ChiliPiperDS;
  if (!_parent.$el[0].hasAttribute("data-required")) return;

  const additionalRequiredFields = _parent.$el[0].getAttribute("data-required");
  const additionalRequiredFieldsArray = additionalRequiredFields.split(",");
  const showRequiredFieldError = ($field) => {
    $field.addClass("invalid error");
    const $errorBlock = $field.closest(".input").next(".hs-error-msgs");

    const errorHTML = `
      <ul class="no-list hs-error-msgs inputs-list custom-error" role="alert">
        <li><label class="hs-error-msg hs-main-font-element">  Please complete this required field.</label>
        </li>
      </ul>
    `;

    if ($errorBlock.length <= 0) {
      $field.closest(".input").after(errorHTML);
    } else {
      $errorBlock.html(errorHTML);
    }
  };

  const clearRequiredFieldError = ($field) => {
    $field.removeClass("invalid error");
    $field.closest(".input").next(".custom-error").remove();
  };

  additionalRequiredFieldsArray.map((v, i) => {
    const $field = $form.find(`.hs-input[name="${v}"]`);
    $field.attr("required", true).on("blur input focus", () => {
      if (!$field.val()) {
        if (helpers.shouldDebug("ds3"))
          console.log(
            "[ChiliPiperDS.FormHelpers] additonalRequiredField is empty",
          );
        showRequiredFieldError($field);
      } else {
        clearRequiredFieldError($field);
      }
    });
  });
};

ChiliPiperDS_FormHelpers.getAdditionalRequiredFields = function ($form) {
  var _parent = ChiliPiperDS;
  if (!_parent.$el[0].hasAttribute("data-required")) return;

  const additionalRequiredFields = _parent.$el[0].getAttribute("data-required");
  const additionalRequiredFieldsArray = additionalRequiredFields.split(",");

  var arf = [];

  additionalRequiredFieldsArray.map((v, i) => {
    $form.find(`.hs-input[name="${v}"]`).attr("required", true);

    arf.push($form.find(`.hs-input[name="${v}"]`));
  });

  return arf;
};

ChiliPiperDS_FormHelpers.setFieldLabelVisibilty = function ($form) {
  const inputFields = $form.find(
    ".hs-form-field:not(.hs-fieldtype-booleancheckbox):not(.hs-fieldtype-radio)",
  );
  inputFields.each(function () {
    let input = $(this).find(".hs-input");
    if (input.val()) {
      $(this).addClass("show-field-label");
    }

    // Show/hide label on focus & blur events
    input
      .focus(function () {
        $(this).closest(".hs-form-field").addClass("show-field-label");
      })
      .blur(function () {
        if (!this.value) {
          $(this).closest(".hs-form-field").removeClass("show-field-label");
        }
      });
  });
};

ChiliPiperDS_FormHelpers.enableSuccessMessage = function ($form) {
  // schedule_all_ratings="1" on the shortcode: treat every timeline answer
  // (Hot/Warm/Cold — the "How soon…?" rating field) as scheduler-eligible.
  // Partner pages (e.g. the Score webinar /demo instance) want Warm/Cold
  // leads booking too; the CP flow's routing rules must match them as well.
  var _parent = ChiliPiperDS;

  if (_parent.$el && _parent.$el[0].hasAttribute("data-schedule-all-ratings"))
    return true;

  // Prevents form from graying out on submission if the lead is considered Cold or Warm
  return $form.find('[name="rating"]').length > 0 &&
    ($form.find('[name="rating"]').val() === "Warm" ||
      $form.find('[name="rating"]').val() === "Cold")
    ? false
    : true;
};

ChiliPiperDS_FormHelpers.field_company = function ($form) {
  const $company = $form.find('input[name="company"]');
  $company.attr("placeholder", "Business Name");
};

ChiliPiperDS_FormHelpers.field_email = function ($form) {
  const $email = $form.find('input[name="email"]');
  $email.attr("placeholder", "Email Address");
};

ChiliPiperDS_FormHelpers.field_name = function ($form) {
  const $nameField = $form.find('input[name="full_name"]');
  const $firstName = $form.find('input[name="firstname"]');
  const $lastName = $form.find('input[name="lastname"]');
  const errorMsg = `
    <ul class="no-list hs-error-msgs inputs-list" role="alert">
      <li>
        <label class="hs-error-msg hs-main-font-element">Please ensure you enter a first and last name with more than 2 letters and no special characters.
        </label>
      </li>
    </ul>
  `;
  const nameRegex =
    /^([a-zA-Z.]{2,}\s[a-zA-Z]{1,}'?-?[a-zA-Z]{2,}\s?([a-zA-Z]{1,})?)$/;

  if ($nameField.attr("type") === "hidden") {
    $firstName.on("input blur", function () {
      if (helpers.shouldDebug("ds3"))
        console.log("[ChiliPiperDS.FormHelpers] firstName:", $firstName.val());
      $nameField.val($firstName.val() + " " + $lastName.val());
      if (helpers.shouldDebug("ds3"))
        console.log("[ChiliPiperDS.FormHelpers] nameField:", $nameField.val());
    });
    $lastName.on("input blur", function () {
      if (helpers.shouldDebug("ds3"))
        console.log("[ChiliPiperDS.FormHelpers] lastName:", $lastName.val());
      $nameField.val($firstName.val() + " " + $lastName.val());
      if (helpers.shouldDebug("ds3"))
        console.log("[ChiliPiperDS.FormHelpers] nameField:", $nameField.val());
    });
  } else {
    $nameField.on("input blur", function () {
      const val = $(this).val().trim();

      if (!nameRegex.test(val)) {
        $nameField.addClass("invalid error");

        const $errorBlock = $nameField.closest(".input").next(".hs-error-msgs");
        if ($errorBlock.length <= 0) {
          $nameField.closest(".input").after(errorMsg);
        } else {
          $errorBlock.html($(errorMsg).html());
        }
      } else {
        $nameField.removeClass("invalid error");
        $nameField.closest(".input").next(".hs-error-msgs").remove();
      }

      const parts = val.split(/\s+/);
      $firstName.val(parts[0] || "");
      $lastName.val(parts.slice(1).join(" ") || "");
    });
  }
};

ChiliPiperDS_FormHelpers.field_industry = function ($form) {
  // Setup Industry Fields Fns
  if ($form.find('input[name="industry"]').length > 0) {
    $form.find('input[name="industry"]').closest(".hs-form-field").hide();
    $form
      .find('select[name="industry_select"]')
      .closest(".input")
      .siblings("label")
      .append('<span class="hs-form-required">*</span>');
    $form.find('select[name="industry_select"]').change(function () {
      $form.find('input[name="industry"]').val($(this).val());
      if ($(this).val() === "Other") {
        $form
          .find('input[name="industry"]')
          .closest(".hs-form-field")
          .slideDown(200);
      } else {
        $form
          .find('input[name="industry"]')
          .closest(".hs-form-field")
          .slideUp(200);
      }
    });
  } else {
    $form
      .find('select[name="industry_select"]')
      .closest(".hs-form-field")
      .hide();
  }
};

/**
 * Prefill HS form fields from URL params — trial-onboarding deep links
 * (prefill="url" on the shortcode). The product links to the page with the
 * user's known details so the form arrives filled:
 *
 *   ?show_scheduler=1&email=…&firstname=…&lastname=…&company=…&phone=…
 *
 * full_name is composed from firstname + lastname when the form uses the
 * combined field. Values a param doesn't provide are left untouched.
 */
ChiliPiperDS_FormHelpers.fields_prefill = function ($form) {
  var _parent = ChiliPiperDS;

  if (!_parent.$el || !_parent.$el[0].hasAttribute("data-prefill")) return;

  const urlParams = new URLSearchParams(window.location.search);
  const map = {
    email: "email",
    firstname: "firstname",
    lastname: "lastname",
    company: "company",
    phone: "phone",
  };

  Object.entries(map).forEach(([param, field]) => {
    const value = urlParams.get(param);

    if (value !== null && value !== "") {
      $form.find(`input[name="${field}"]`).val(value).trigger("input");
    }
  });

  // Combined full-name field (used when firstname/lastname are hidden)
  const first = urlParams.get("firstname") || "";
  const last = urlParams.get("lastname") || "";

  if ((first || last) && $form.find('input[name="full_name"]').length) {
    $form
      .find('input[name="full_name"]')
      .val((first + " " + last).trim())
      .trigger("input");
  }

  // The visible phone field on DS3-style forms is phone_input_only (the
  // hidden `phone` input is HubSpot's own) — prefill it from the same param.
  const phone = urlParams.get("phone");

  if (
    phone !== null &&
    phone !== "" &&
    $form.find('input[name="phone_input_only"]').length
  ) {
    $form.find('input[name="phone_input_only"]').val(phone).trigger("input");
  }

  if (helpers.shouldDebug("ds3"))
    console.log(
      "[ChiliPiperDS.FormHelpers] fields_prefill applied from URL params",
    );
};

ChiliPiperDS_FormHelpers.fields_utms = function ($form) {
  // Shortcode utms are PAGE DEFAULTS — applied first so explicit URL
  // params can override them below (same precedence as HSForm). Positional:
  // [source, medium, campaign, term, content], empty slot = not pinned.
  var _parent = ChiliPiperDS;
  var $parentEl = _parent.$el;
  const shortcode_utms = $parentEl.data("utms")
    ? $parentEl.data("utms").split(",")
    : false;
  if (shortcode_utms) {
    shortcode_utms.map((utm, i) => {
      const utm_names = [
        "utm_source",
        "utm_medium",
        "utm_campaign",
        "utm_term",
        "utm_content",
      ];
      if (utm !== "") {
        $form.find(`input[name="${utm_names[i]}"]`).val(utm);
      }
    });
  }

  // URL params WIN over the shortcode defaults — partner links must
  // attribute correctly no matter what the page pins.
  const urlParams = new URLSearchParams(window.location.search);
  const url_utms = {
    utm_source: urlParams.get("utm_source"),
    utm_medium: urlParams.get("utm_medium"),
    utm_campaign: urlParams.get("utm_campaign"),
    utm_term: urlParams.get("utm_term"),
    utm_content: urlParams.get("utm_content"),
  };

  Object.entries(url_utms).forEach(([key, value]) => {
    if (value !== null) {
      $form.find(`input[name="${key}"]`).val(value);
    }
  });

  // Check if utm_medium is empty
  if ($form.find('input[name="utm_medium"]').val() === "") {
    if (helpers.shouldDebug("ds3"))
      console.info("[ChiliPiperDS.FormHelpers] set default utm_medium");
    $form.find('input[name="utm_medium"]').val("website");
  }

  const impactId = urlParams.get("irclickid");
  if (impactId) {
    $form.find('input[name="impact_id"]').val(impactId);
  }

  $form.find('input[name^="utm_"]').each(function () {
    if (helpers.shouldDebug("ds3"))
      console.log(
        `[ChiliPiperDS.FormHelpers] ${$(this).attr("name")}: ${$(this).val()}`,
      );
  });
};

ChiliPiperDS_FormHelpers.fields_adps = function ($form) {
  var _parent = ChiliPiperDS;
  var $parentEl = _parent.$el;

  // Set ADP field values
  for (let i = 1; i < 5; i++) {
    let ADP = $form.find(`[name="additional_datapoint_${i}"]`);
    if (ADP.length > 0 && $parentEl[0].hasAttribute(`data-adp${i}`)) {
      ADP.val($parentEl.attr(`data-adp${i}`));
      if (helpers.shouldDebug("ds3"))
        console.log(`[ChiliPiperDS.FormHelpers] ADP${i}: ${ADP.val()}`);
    }
  }
};

ChiliPiperDS_FormHelpers.getState = function (zip) {
  /* Ensure param is a string to prevent unpredictable parsing results */
  /* Ensure we have exactly 5 characters to parse */
  if (typeof zip !== "string" && zip.length !== 5) {
    return;
  }

  /* Ensure we don't parse strings starting with 0 as octal values */
  const zipcode = parseInt(zip, 10);
  let st;
  let state;

  /* Code cases alphabetized by state */
  if (zipcode >= 35000 && zipcode <= 36999) {
    st = "AL";
    state = "Alabama";
  } else if (zipcode >= 99500 && zipcode <= 99999) {
    st = "AK";
    state = "Alaska";
  } else if (zipcode >= 85000 && zipcode <= 86999) {
    st = "AZ";
    state = "Arizona";
  } else if (zipcode >= 71600 && zipcode <= 72999) {
    st = "AR";
    state = "Arkansas";
  } else if (zipcode >= 90000 && zipcode <= 96699) {
    st = "CA";
    state = "California";
  } else if (zipcode >= 80000 && zipcode <= 81999) {
    st = "CO";
    state = "Colorado";
  } else if (
    (zipcode >= 6000 && zipcode <= 6389) ||
    (zipcode >= 6391 && zipcode <= 6999)
  ) {
    st = "CT";
    state = "Connecticut";
  } else if (zipcode >= 19700 && zipcode <= 19999) {
    st = "DE";
    state = "Delaware";
  } else if (zipcode >= 32000 && zipcode <= 34999) {
    st = "FL";
    state = "Florida";
  } else if (
    (zipcode >= 30000 && zipcode <= 31999) ||
    (zipcode >= 39800 && zipcode <= 39999)
  ) {
    st = "GA";
    state = "Georgia";
  } else if (zipcode >= 96700 && zipcode <= 96999) {
    st = "HI";
    state = "Hawaii";
  } else if (zipcode >= 83200 && zipcode <= 83999 && zipcode != 83414) {
    st = "ID";
    state = "Idaho";
  } else if (zipcode >= 60000 && zipcode <= 62999) {
    st = "IL";
    state = "Illinois";
  } else if (zipcode >= 46000 && zipcode <= 47999) {
    st = "IN";
    state = "Indiana";
  } else if (zipcode >= 50000 && zipcode <= 52999) {
    st = "IA";
    state = "Iowa";
  } else if (zipcode >= 66000 && zipcode <= 67999) {
    st = "KS";
    state = "Kansas";
  } else if (zipcode >= 40000 && zipcode <= 42999) {
    st = "KY";
    state = "Kentucky";
  } else if (zipcode >= 70000 && zipcode <= 71599) {
    st = "LA";
    state = "Louisiana";
  } else if (zipcode >= 3900 && zipcode <= 4999) {
    st = "ME";
    state = "Maine";
  } else if (zipcode >= 20600 && zipcode <= 21999) {
    st = "MD";
    state = "Maryland";
  } else if (
    (zipcode >= 1000 && zipcode <= 2799) ||
    zipcode == 5501 ||
    zipcode == 5544
  ) {
    st = "MA";
    state = "Massachusetts";
  } else if (zipcode >= 48000 && zipcode <= 49999) {
    st = "MI";
    state = "Michigan";
  } else if (zipcode >= 55000 && zipcode <= 56899) {
    st = "MN";
    state = "Minnesota";
  } else if (zipcode >= 38600 && zipcode <= 39999) {
    st = "MS";
    state = "Mississippi";
  } else if (zipcode >= 63000 && zipcode <= 65999) {
    st = "MO";
    state = "Missouri";
  } else if (zipcode >= 59000 && zipcode <= 59999) {
    st = "MT";
    state = "Montana";
  } else if (zipcode >= 27000 && zipcode <= 28999) {
    st = "NC";
    state = "North Carolina";
  } else if (zipcode >= 58000 && zipcode <= 58999) {
    st = "ND";
    state = "North Dakota";
  } else if (zipcode >= 68000 && zipcode <= 69999) {
    st = "NE";
    state = "Nebraska";
  } else if (zipcode >= 88900 && zipcode <= 89999) {
    st = "NV";
    state = "Nevada";
  } else if (zipcode >= 3000 && zipcode <= 3899) {
    st = "NH";
    state = "New Hampshire";
  } else if (zipcode >= 7000 && zipcode <= 8999) {
    st = "NJ";
    state = "New Jersey";
  } else if (zipcode >= 87000 && zipcode <= 88499) {
    st = "NM";
    state = "New Mexico";
  } else if (
    (zipcode >= 10000 && zipcode <= 14999) ||
    zipcode == 6390 ||
    zipcode == 501 ||
    zipcode == 544
  ) {
    st = "NY";
    state = "New York";
  } else if (zipcode >= 43000 && zipcode <= 45999) {
    st = "OH";
    state = "Ohio";
  } else if (
    (zipcode >= 73000 && zipcode <= 73199) ||
    (zipcode >= 73400 && zipcode <= 74999)
  ) {
    st = "OK";
    state = "Oklahoma";
  } else if (zipcode >= 97000 && zipcode <= 97999) {
    st = "OR";
    state = "Oregon";
  } else if (zipcode >= 15000 && zipcode <= 19699) {
    st = "PA";
    state = "Pennsylvania";
  } else if (zipcode >= 300 && zipcode <= 999) {
    st = "PR";
    state = "Puerto Rico";
  } else if (zipcode >= 2800 && zipcode <= 2999) {
    st = "RI";
    state = "Rhode Island";
  } else if (zipcode >= 29000 && zipcode <= 29999) {
    st = "SC";
    state = "South Carolina";
  } else if (zipcode >= 57000 && zipcode <= 57999) {
    st = "SD";
    state = "South Dakota";
  } else if (zipcode >= 37000 && zipcode <= 38599) {
    st = "TN";
    state = "Tennessee";
  } else if (
    (zipcode >= 75000 && zipcode <= 79999) ||
    (zipcode >= 73301 && zipcode <= 73399) ||
    (zipcode >= 88500 && zipcode <= 88599)
  ) {
    st = "TX";
    state = "Texas";
  } else if (zipcode >= 84000 && zipcode <= 84999) {
    st = "UT";
    state = "Utah";
  } else if (zipcode >= 5000 && zipcode <= 5999) {
    st = "VT";
    state = "Vermont";
  } else if (
    (zipcode >= 20100 && zipcode <= 20199) ||
    (zipcode >= 22000 && zipcode <= 24699) ||
    zipcode == 20598
  ) {
    st = "VA";
    state = "Virginia";
  } else if (
    (zipcode >= 20000 && zipcode <= 20099) ||
    (zipcode >= 20200 && zipcode <= 20599) ||
    (zipcode >= 56900 && zipcode <= 56999)
  ) {
    st = "DC";
    state = "Washington DC";
  } else if (zipcode >= 98000 && zipcode <= 99499) {
    st = "WA";
    state = "Washington";
  } else if (zipcode >= 24700 && zipcode <= 26999) {
    st = "WV";
    state = "West Virginia";
  } else if (zipcode >= 53000 && zipcode <= 54999) {
    st = "WI";
    state = "Wisconsin";
  } else if ((zipcode >= 82000 && zipcode <= 83199) || zipcode == 83414) {
    st = "WY";
    state = "Wyoming";
  } else {
    st = null;
    state = null;
    console.log("No state found matching", zipcode);
  }

  /* Return `state` for full name or `st` for postal abbreviation */
  return state;
};

ChiliPiperDS_FormHelpers.setState = function ($form, state) {
  var _parent = ChiliPiperDS;
  var $parentEl = _parent.$el;
  var stateVal = state
    ? state
    : $parentEl[0].hasAttribute("data-state")
      ? $parentEl[0].getAttribute("data-state")
      : "";

  $form.find('[name="state"]').val(stateVal);

  if (helpers.shouldDebug("ds3"))
    console.info(`[ChiliPiperDS.FormHelpers] state has changed to ${stateVal}`);
};

ChiliPiperDS_FormHelpers.field_country = function ($form) {
  // Set country code for form
  let countryCode = thryvSettings.thryvCountry.slice(0, 2);
  $form.find('[name="country_code"]').val(countryCode);

  // If country select is present
  $form.find('[name="country_select"] > option:eq(0)').prop("selected", true);
  $form.find('[name="country_select"]').change(function () {
    $form.find('[name="country_code"]').val($(this).val());
  });
};

ChiliPiperDS_FormHelpers.fields_profile = function ($form) {
  // Populate with session storage if blank
  let demoProfile =
    sessionStorage.getItem("demoProfile") !== null
      ? JSON.parse(sessionStorage.getItem("demoProfile"))
      : false;
  if (demoProfile) {
    let $nameField = $form.find('input[name="full_name"]');
    let $companyField = $form.find('input[name="company"]');
    let $emailField = $form.find('input[name="email"]');
    let $phoneField = $form.find('input[name="phone_input_only"]');

    if ($nameField.val() === "") $nameField.val(demoProfile.name).focus();

    if ($companyField.val() === "")
      $companyField.val(demoProfile.company).focus();

    if ($emailField.val() === "") $emailField.val(demoProfile.email).focus();

    if ($phoneField.val() === "") $phoneField.val(demoProfile.phone).focus();
  }
};

ChiliPiperDS_FormHelpers.field_zip = function ($form) {
  const _this = this;
  $form
    .find('input[name="zip"]')
    .attr({
      pattern: "[0-9]{5}",
      maxlength: 5,
    })
    .on("keyup keydown input focus blur", function () {
      let formattedVal = helpers.numOnly($(this).val());
      $(this).val(formattedVal);
      _this.setState($form, _this.getState(formattedVal));
    });
};

ChiliPiperDS_FormHelpers.field_franchisor = function ($form) {
  var _parent = ChiliPiperDS;
  var $parentEl = _parent.$el;
  $form.find('input[name="franchisor"]').change(function () {
    const meetingTypeField = $form.find('[name="meeting_type_cp__c"]');

    if ($form.find('input[name="franchisor"]:checked').val() === "Yes") {
      meetingTypeField.val("1779374801182"); // Old qualified segment id. Change later.
    } else {
      meetingTypeField.val("779374668932"); // Old qualified segment id. Change later.
    }

    if (helpers.shouldDebug("ds3"))
      console.info(
        `[ChiliPiperDS.FormHelpers] meetingType has changed to experiencce-${$parentEl.attr("data-meetingType")}`,
      );
  });
};

ChiliPiperDS_FormHelpers.field_website = function ($form) {
  var _parent = ChiliPiperDS;
  var $parentEl = _parent.$el;
  const $websiteField = $form.find('input[name="website"]').closest("fieldset");

  if ($parentEl.attr("data-experience") === "regional") {
    $websiteField.hide();
    $websiteField.before(
      '<div class="has-website-options"><label>Do you have a website?</label><div class="inputs"><label for="websiteYes"><input type="radio" id="websiteYes" name="hasWebsite" value="Yes" /> Yes</label><label for="websiteNo"> <input type="radio" id="websiteNo" name="hasWebsite" value="No" /> No</label></div></div>',
    );

    $(document).delegate('input[name="hasWebsite"]', "change", function () {
      if ($(this).val() === "Yes") {
        $websiteField.show();
      } else if ($(this).val() === "No") {
        $websiteField
          .hide()
          .find('input[name="website"]')
          .val("")
          .closest(".hs-form-field")
          .removeClass("show-field-label");
      }
    });
  }
};

ChiliPiperDS_FormHelpers.field_salesChannel = function ($form) {
  $form.find('select[name="sales_channel"]').change(function () {
    let currVal = $form.find('select[name="sales_channel"]').val();
    if (currVal !== "") $form.find('input[name="utm_medium"]').val(currVal);
    if (helpers.shouldDebug("ds3"))
      console.info(
        `[ChiliPiperDS.FormHelpers] utm_medium has changed to ${currVal}`,
      );
  });
};

ChiliPiperDS_FormHelpers.fields_partner = function ($form) {
  var _parent = ChiliPiperDS;
  var $parentEl = _parent.$el;
  var params = new URLSearchParams(window.location.search);
  var psPartnerKey = params.get("ps_partner_key") ?? params.get("partner_key");

  if ($parentEl.attr("data-experience") === "partner" && psPartnerKey) {
    let psPartnerInfo = params.has("ps_partner_key")
      ? helpers.psPartnerLookup(atob(psPartnerKey))
      : helpers.psPartnerLookup(psPartnerKey);

    if (helpers.shouldDebug("ds3"))
      console.info(
        `[ChiliPiperDS.FormHelpers] PartnerStack Partner Info:`,
        psPartnerInfo,
      );

    $form.find('[name="partner_id"]').val(psPartnerInfo?.partner_key);
    $form
      .find('[name="partner_name"]')
      .val(`${psPartnerInfo?.first_name} ${psPartnerInfo?.last_name}`);
  }
};

ChiliPiperDS_FormHelpers.field_requestedDemoType = function (
  $form,
  meetingType,
) {
  const _this = this;
  const $phoneField = $form.find('input[name="phone_input_only"]');
  const $optOutField = $form.find('input[name="smsoptout__c"]');
  const $franchisorField = $form.find('input[name="franchisor"]');
  const $consentField = _this.getConsentField($form);

  helpers.hsPrivacyConsentInit($form, "txt-optin", "thryv-sapphire", "demo");
  $form.find(".legal-consent-container").addClass("mt-3 mb-1");
  $form
    .find(".legal-consent-container")
    .closest("fieldset")
    .insertBefore(
      $form
        .find(".legal-consent-container")
        .closest("fieldset")
        .prev("fieldset"),
    );

  const $demoTypeInputs = $form.find('input[name="requested_demo_type"]');

  var _parent = ChiliPiperDS;
  var $parentEl = _parent.$el;
  if ($parentEl[0].hasAttribute("data-submit-text")) {
    $form
      .find('input[name="requested_demo_type"][value="demo_scheduled"]')
      .siblings("span")
      .text($parentEl[0].getAttribute("data-submit-text"));
  }

  const showPrivacyConsentError = function () {
    $consentField.addClass("invalid error");
    if ($consentField.closest(".input").next(".hs-error-msgs").length <= 0) {
      $consentField
        .closest(".input")
        .after(
          '<ul class="no-list hs-error-msgs inputs-list" role="alert"><li><label class="hs-error-msg hs-main-font-element">Please confirm that you have read and agree to the privacy statement by checking the box.</label></li></ul>',
        );
    } else {
      $consentField
        .closest(".input")
        .next(".hs-error-msgs")
        .html(
          '<li><label class="hs-error-msg hs-main-font-element">Please confirm that you have read and agree to the privacy statement by checking the box.</label></li>',
        );
    }
  };

  $consentField.change(function () {
    if ($(this).is(":checked")) {
      $optOutField.val("false");
    } else {
      $optOutField.val("true");
    }
  });

  $demoTypeInputs.prop("checked", false);

  $demoTypeInputs.on("click", function (e) {
    // Update engaged demo type field
    var engagedDemoValue =
      $(this).val() === "demo_now" ? "On Demand" : "Scheduled";
    $form.find('[name="engageddemotype__c"]').val(engagedDemoValue);

    // Check required fields
    const $requiredFields = $form.find(
      '.hs-input[required]:not([name="requested_demo_type"])',
    );
    const formHasErrors = () => {
      if ($franchisorField.length > 0) $franchisorField.focus();
      $requiredFields.focus();
      $phoneField.focus().blur();

      const hasErrors =
        $form
          .find(".hs-error-msg")
          .closest(".hs-form-field:not(.hs_requested_demo_type)").length > 0;
      const isAnyRequiredEmpty = !$requiredFields.val();
      const isConsentMissing = !$consentField.is(":checked");
      const isFranchisorMissing =
        $franchisorField.length <= 0 ? false : !$franchisorField.is(":checked");

      return (
        hasErrors ||
        isAnyRequiredEmpty ||
        isFranchisorMissing /*|| isConsentMissing*/
      );
    };

    const isRequiredEmpty = !$requiredFields.val();
    if ($(this).val() === "demo_now" && isRequiredEmpty) {
      _this.redirectToDemoVideo();
    } else if (formHasErrors()) {
      e.preventDefault();
      $demoTypeInputs.prop("checked", false);
    }
  });

  var eventNames = "change";
  $demoTypeInputs.on(eventNames, function () {
    if (helpers.shouldDebug("ds3"))
      console.log(
        "[ChiliPiperDS.FormHelpers] field_requestedDemoType:",
        $demoTypeInputs,
      );

    const hasErrors = $form.find(".hs-error-msg").length > 0;
    const isChecked = $demoTypeInputs.is(":checked");

    var _parent = ChiliPiperDS;
    var $parentEl = _parent.$el;

    if (!hasErrors && isChecked) {
      const $requiredFields = $form.find(
        '.hs-input[required]:not([name="requested_demo_type"])',
      );
      const isRequiredEmpty = !$requiredFields.val();

      if (!isRequiredEmpty) $phoneField.focus().blur();

      setTimeout(function () {
        if (!isRequiredEmpty) {
          _this.submitForm($form);
        }
      }, 100);
    } else {
      $demoTypeInputs.prop("checked", false);
      if (helpers.shouldDebug("ds3"))
        console.info("[ChiliPiperDS.FormHelpers] form has validation errors");
    }
  });
};

ChiliPiperDS_FormHelpers.submitForm = function ($form) {
  const _this = this;
  var _parent = ChiliPiperDS;

  if (helpers.shouldDebug("ds3"))
    console.log("[ChiliPiperDS.FormHelpers] submitForm", _parent.count++);

  const $submitBtn = this.getSubmitBtn($form);
  $submitBtn.prop("disabled", false);
  $submitBtn.trigger("click");

  this.deactivateIntercom();
  this.saveDemoProfile($form);

  helpers.Cookie.set("demoVideoAccessGranted", "1");
  $(".getdemonow-btn").remove();

  if (!_this.enableSuccessMessage($form)) {
    $parentEl.find('[id^="lead-info-form-"]').addClass("show-success-message");
  } else {
    this.activatePlaceholderForm($form);
  }

  _parent.$el.find(".form-instructions").hide();
  $form.hide();
};

ChiliPiperDS_FormHelpers.activatePlaceholderForm = function ($form) {
  var _parent = ChiliPiperDS;
  var $parentEl = _parent.$el;
  var $formCopy = $form;
  var $formSuccess = $parentEl.find("#lead-info-form-success .hs-form-copy");

  if (
    typeof qualified === "function" ||
    $parentEl[0].hasAttribute("data-calendly")
  ) {
    $formSuccess.html($formCopy.clone(true));
  }

  if (helpers.shouldDebug("ds3"))
    console.log(
      "[ChiliPiperDS.FormHelpers] activatePlaceholderForm",
      $formSuccess,
    );
};

ChiliPiperDS_FormHelpers.saveDemoProfile = function ($form) {
  let name = $form.find('input[name="full_name"]').val();
  let company = $form.find('input[name="company"]').val();
  let email = $form.find('input[name="email"]').val();
  let phone = $form.find('input[name="phone_input_only"]').val();

  // Populate session storage
  sessionStorage.setItem(
    "demoProfile",
    JSON.stringify({
      name,
      company,
      email,
      phone,
    }),
  );
};

ChiliPiperDS_FormHelpers.deactivateIntercom = function () {
  if (typeof Intercom !== "function") return;

  Intercom("shutdown");
  $(".custom-intercom-launcher").removeClass("active");
};

ChiliPiperDS_FormHelpers.setHubspotContactId = function ($form) {
  // adding a delay because the contact id is not available right away when its a new email
  setTimeout(function () {
    $.ajax({
      type: "POST",
      url: thryvSettings.ajaxurl,
      data:
        "email=" +
        $form.find('input[name="email"]').val() +
        "&action=getHubspotID",
      success: function (response) {
        if (helpers.shouldDebug("ds3"))
          console.log(
            "[ChiliPiperDS.FormHelpers] hubspot contact id:",
            response,
          );
        if ("data" in response && response.data != "") {
          var hs_contact_info = JSON.parse(response.data);
          localStorage.setItem("thryv_lead", hs_contact_info.id);
          localStorage.setItem("thryv_lead_hubspot", hs_contact_info.id);
        }
      },
    });
  }, 500 * 8);
};

export default ChiliPiperDS_FormHelpers;
